module.exports = __webpack_public_path__ + "img/avatar-kurt-kemple.510c3e38.jpg";